import styled from 'styled-components';

const Spacing = styled.div<{ size: number }>`
  flex: none;
  height: ${({ size }) => `${size}px`};
`;

export default Spacing;
